import React from "react";
import "./GroupTrip.css";
import MountainAdventureCamp from "../../assets/MountainAdventureCamp.png";
import CityExplorationTour from "../../assets/CityExplorationTour.png";
import BeachFunGetaway from "../../assets/BeachFunGetaway.png";
import WildlifeSafariTrip from "../../assets/WildlifeSafariTrip.png";
import IslandHoppingTour from "../../assets/MountainAdventureCamp.png";
import CulturalHeritageJourney from "../../assets/CulturalHeritageJourney.png";
import { useNavigate } from "react-router-dom";
const groupTrips = [
  {
    title: "Mountain Adventure Camp",
    image: MountainAdventureCamp,
    description:
      "Experience thrilling mountain adventures with your group surrounded by breathtaking landscapes and fresh air. Enjoy trekking, campfire nights, team building games, and scenic sunrise views. Strengthen friendships while creating unforgettable memories in a peaceful natural setting.",
    link: "/tour-package-data",
  },
  {
    title: "Beach Fun Getaway",
    image: BeachFunGetaway,
    description:
      "Enjoy a lively beach vacation filled with sunshine, water sports, and relaxing seaside moments. Participate in group activities, beach volleyball, and sunset walks along the shore. Share laughter, adventure, and unforgettable experiences together.",
    link: "/tour-package-data",
  },
  {
    title: "City Exploration Tour",
    image: CityExplorationTour,
    description:
      "Discover vibrant city life with guided tours, cultural landmarks, and exciting nightlife. Explore famous attractions, try local cuisines, and capture stunning photographs. Perfect for groups seeking entertainment, learning, and unforgettable urban adventures.",
    link: "/tour-package-data",
  },
  {
    title: "Wildlife Safari Trip",
    image: WildlifeSafariTrip,
    description:
      "Embark on an exciting wildlife safari adventure with your group through scenic forests and national parks. Spot majestic animals, enjoy nature walks, and learn about conservation. A perfect combination of thrill and exploration.",
    link: "/tour-package-data",
  },
  {
    title: "Island Hopping Tour",
    image: IslandHoppingTour,
    description:
      "Explore beautiful islands with crystal clear waters and sandy beaches. Enjoy boat rides, snorkeling activities, and relaxing coastal views. Ideal for groups seeking adventure, bonding time, and unforgettable tropical experiences.",
    link: "/tour-package-data",
  },
  {
    title: "Cultural Heritage Journey",
    image: CulturalHeritageJourney,
    description:
      "Travel together to explore historical monuments, traditional villages, and rich cultural heritage sites. Experience local traditions, authentic cuisine, and vibrant festivals while strengthening group connections through meaningful travel experiences.",
    link: "/tour-package-data",
  },
];

const GroupTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="group-container">
      <h2 className="group-title">Group Trip Packages</h2>

      <div className="group-grid">
        {groupTrips.map((trip, index) => (
          <div
            className="group-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="group-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GroupTrip;
